/**
 * SelectListAggregateWarning — single warning-icon button surfaced next to a
 * non-aggregate SELECT item when the query mixes aggregates and non-aggregates
 * AND the column is not already in GROUP BY. Click triggers `addGroupBy` with
 * the column's expression text.
 *
 * Extracted from SelectList.tsx to keep that file under the 200-line budget.
 *
 * PRD: Ralph/VisualQueryEditorEdit/PRD.md § Slice: Edit — add/remove GROUP BY.
 */

import { AlertTriangle } from 'lucide-react';

import { Button } from '../../../../../components/ui/button';
import type { VqeEditContext } from '../../edit/editContext';
import { toCommitCtx } from '../../edit/editContext';
import { VqeTooltip } from '../common/VqeTooltip';
import { addGroupByExpression } from '../../edit/edits/addGroupBy';

export interface SelectListAggregateWarningProps {
  readonly editContext: VqeEditContext;
  readonly columnText: string;
  readonly index: number;
}

export function SelectListAggregateWarning({
  editContext,
  columnText,
  index,
}: SelectListAggregateWarningProps) {
  return (
    <VqeTooltip content="Auto-add this column to GROUP BY">
      <Button
        type="button"
        variant="ghost"
        size="sm"
        className="h-5 w-5 p-0 text-warning hover:text-amber-700"
        data-testid={`vqe-select-list-needs-group-by-${index}`}
        aria-label="Auto-add to GROUP BY"
        onClick={() => {
          void addGroupByExpression(columnText, toCommitCtx(editContext));
        }}
      >
        <AlertTriangle className="h-3.5 w-3.5" />
      </Button>
    </VqeTooltip>
  );
}
